module.exports = __webpack_public_path__ + "static/media/cheese.07ea5d8c.jpg";